import styled from '@emotion/styled';
import { spacing, borderRadius, palette } from 'theme';

export const IconCard = styled.div({
  width: 'fit-content',
  maxWidth: '80px',
  minHeight: '100px',
  paddingBlockStart: spacing[20],
  paddingBlockEnd: spacing[8],
  backgroundColor: palette.neutral[100],
  borderRadius: borderRadius.lg,
  userSelect: 'none',

  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: spacing[12],

  '& > span': {
    marginInline: spacing[8],
    textAlign: 'center',
    lineHeight: '10px',
  },
});
